import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneConfermaComponent } from './conservazione-conferma';

export const ConservazioneConfermaModule: string = ng
    .module('conservazione-conferma', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('conservazioneConfermaComponent', ConservazioneConfermaComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/conservazione-conferma/conservazione-conferma.module.ts